/**
 * Match URL using various match types
 *
 * Ported from [optly.match.matchUrl@06b84fe4c24d26712823dff967db3632093d64fd](https://github.com/optimizely/optimizely/blob/06b84fe4c24d26712823dff967db3632093d64fd/src/www/js/shared/match.js)
 *
 * UnitTest: src/plugins/view_feature_url/matchers/url_tests.js
 * @module
 */
var _ = require('optimizely-client-fn');

/**
 * Match URL to cond
 *
 * @param {string} url
 * @param {Object} cond
 * @param {string} cond.match
 * @param {string} cond.value
 * @returns {boolean}
 */
module.exports = function(url:string, cond:any): boolean {
  url = stripVarFromQuery(url);
  var condValue = cond.value;
  switch (cond.match) {
    case 'exact':
      url = stripUrl(url);
      return url === stripUrl(condValue);
    case 'regex':
      try {
        return Boolean(url.match(condValue));
      } catch (error) {} // eslint-disable-line
      return false;
    case 'simple':
      url = simplifyUrl(url);
      condValue = simplifyUrl(condValue);
      return url === condValue;
    case 'substring':
      url = stripUrl(url, true);
      condValue = stripUrl(condValue, true);
      return url.indexOf(condValue) !== -1;
    default:
      if (__INVARIANT__) {
        throw new Error('Invalid match type "' + cond.match + '" for URL ' + condValue);
      }
      return false;
  }
};

/**
 * Regexes to match against URL if excludeOptionalPrefixesToStrip not set
 * @private
 */
var OPTIONAL_PREFIXES_TO_STRIP = [
  'www\.'
];

var QUERY_PREFIX = 'optimizely_';

/**
 * Regexes to match against URL (always)
 * @private
 */
var REQUIRED_PREFIXES_TO_STRIP = [
  'https?://.*?\.?optimizelyedit\.(com|test)/',
  'https?://.*\.?optimizelypreview\.(com|test)/',
  'https?://(edit|preview)(-hrd|-devel)?\.optimizely\.(com|test)/',
  'https?://.*?\.?optimizelyedit(-hrd)?\.appspot\.com/',
  'https?://'
];

/**
 * Remove query parameters from URL
 * @param {string} url
 * @returns {string}
 */
function removeParameters (url:string): string {
  // TODO (andrewk) rewrite using utils/location
  var index = url.indexOf('?');
  if (index !== -1) {
    url = url.substring(0, index);
  }
  index = url.indexOf('#');
  if (index !== -1) {
    url = url.substring(0, index);
  }
  return url;
}

/**
 * Remove parameters and strip URL
 * @private
 * @param {string} url
 * @returns {string}
 */
function simplifyUrl (url:string): string {
  return stripUrl(removeParameters(url));
}

/**
 * Remove protocol, edit/preview proxy URL and extraneous trailing
 * characters. Also remove 'www.' unless specified not to.
 * @private
 * @param {string} url
 * @param {boolean} [excludeOptionalPrefixesToStrip]
 * @return {string}
 */
function stripUrl (url:string, excludeOptionalPrefixesToStrip?:boolean): string {
  // TODO (andrewk) rewrite using utils/location
  url = url.replace('/?', '?');
  url = url.toLowerCase().replace(/[/&?]+$/, '');

  // Create a copy of the required prefixes
  var prefixesToStrip = REQUIRED_PREFIXES_TO_STRIP.slice(0);
  if (!excludeOptionalPrefixesToStrip) {
    prefixesToStrip = prefixesToStrip.concat(OPTIONAL_PREFIXES_TO_STRIP);
  }

  var length = prefixesToStrip.length;
  for (var i = 0; i < length; i++) {
    var prefixToStrip = prefixesToStrip[i];

    var prefixRegEx = new RegExp('^' + prefixToStrip);
    url = url.replace(prefixRegEx, '');
  }

  return url;
}

/**
 * Strip out any optimizely_... query parameters from a url.
 * @private
 * @param {string} url
 * @return {string}
 */
function stripVarFromQuery (url:string): string {
  // TODO (andrewk) rewrite using utils/location
  var urlParts = url.split('?');
  if (urlParts[1]) {
    var fragmentParts = urlParts[1].split('#');
    var query = fragmentParts[0];
    var fragment = fragmentParts.slice(1).join('#');
    var urlQueryParts = query.split('&');
    var newQueryParts = [];
    _.each(urlQueryParts, function(queryPart) {
      if (queryPart.indexOf(QUERY_PREFIX) !== 0) {
        newQueryParts.push(queryPart);
      }
    });

    urlParts[1] = '';
    if (newQueryParts.length > 0) {
      urlParts[1] = '?' + newQueryParts.join('&');
    }
    if (fragment) {
      urlParts[1] += '#' + fragment;
    }

    return urlParts.join('');
  }
  return url;
}
